export default "__VITE_ASSET__58437172__"